import { PropsWithChildren } from 'react';

import posthog from 'posthog-js';
import { PostHogProvider as PostHogJSProvider } from 'posthog-js/react';

import { postHogTrackingService } from '@/services/PostHogTrackingService';
import { referralAttributionService } from '@/services/ReferralAttributionService';

postHogTrackingService.init();
referralAttributionService.captureIfNeeded();

export const PostHogProvider = ({ children }: PropsWithChildren) => (
  <PostHogJSProvider client={posthog}>{children}</PostHogJSProvider>
);
